import { makeEroadStyles } from "../../../styles";

const useStyles = makeEroadStyles(
  (theme) => ({
    actions: {
      alignSelf: "center",
      display: "flex",

      "& > *": {
        marginRight: theme.spacing(4),

        "&:last-child": {
          marginRight: 0,
        },
      },
    },
    root: {
      display: "flex",
      justifyContent: "space-between",
    },
    title: {
      ...theme.typography.h5,
      color: theme.colors.onsurfaceFont,
      fontWeight: 500,
      marginBottom: 0,
      textTransform: "lowercase",

      "&:first-letter": {
        textTransform: "uppercase",
      },

      [`@media (max-width: ${theme.breakpoints.values.md - 1}px)`]: {
        // Needs to be using 3.2rem once 20% mobile font size increase removed
        fontSize: 32,
      },

      [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
        // Needs to be using 2.4rem once 20% mobile font size increase removed
        fontSize: 24,
      },
    },
    titleOverrideCase: {
      textTransform: "none",

      "&:first-letter": {
        textTransform: "none",
      },
    },
  }),
  { name: "PageTitle" },
);

export { useStyles };
